import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import {
  clearGroupOffersCache,
  prefetchGroupOffers,
} from "@smeetz/offers-common";
import { useGroupOffersStore } from "@/stores/group-offers.store";
import { LogService } from "@/services/logging";
import { hasSalesStarted } from "../vue-helpers/cash-float";

/**
 * Force-refreshes the active group's offers from the backend, overriding any
 * cached data in both the Pinia store (and its localStorage backing) and the
 * `@smeetz/offers-common` package's module-level cache.
 *
 * Called at app boot (App.vue), after POS config reloads, and on cash-float
 * open — anywhere we want the next discount/offer evaluation to use the
 * latest catalog state.
 */
export async function loadOffers(): Promise<void> {
  const groupId = POSConfigModule.groupId || UserModule.getUserGroupId;
  if (!hasSalesStarted.value || !groupId) return;

  const groupOffersStore = useGroupOffersStore();

  // 1. Hit the backend and overwrite the store (and its persisted copy).
  await groupOffersStore.fetchOffers(groupId);
  // 2. Drop the package's stale cache so its next read goes through our
  //    callback and picks up the freshly stored offers.
  clearGroupOffersCache();
  // 3. Re-warm the package cache from the now-fresh store (no extra API call
  //    — the registered callback returns store data on the second hop).
  await prefetchGroupOffers(groupId);

  LogService.info("Offers fetched for group " + groupId);
}
